import { render, staticRenderFns } from "./DataViewer.vue?vue&type=template&id=46c0e64f&scoped=true&"
import script from "./DataViewer.vue?vue&type=script&lang=js&"
export * from "./DataViewer.vue?vue&type=script&lang=js&"
import style0 from "./DataViewer.vue?vue&type=style&index=0&id=46c0e64f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c0e64f",
  null
  
)

export default component.exports